"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Alert = void 0;
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _proLightSvgIcons = require("@fortawesome/pro-light-svg-icons");
var _proSolidSvgIcons = require("@fortawesome/pro-solid-svg-icons");
var _reactFontawesome = require("@fortawesome/react-fontawesome");
var _Alert = _interopRequireDefault(require("./Alert.styles"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var Alert = function Alert(_ref) {
  var text = _ref.text,
    subText = _ref.subText,
    variant = _ref.variant,
    className = _ref.className,
    onClose = _ref.onClose,
    showCloseButton = _ref.showCloseButton;
  var classes = (0, _Alert["default"])();
  var iconMapping = {
    error: _proLightSvgIcons.faCircleXmark,
    info: _proLightSvgIcons.faInfoCircle,
    warning: _proLightSvgIcons.faExclamationTriangle,
    success: _proLightSvgIcons.faCheckCircle
  };
  return /*#__PURE__*/_react["default"].createElement(_core.Box, {
    className: (0, _clsx["default"])(classes.root, variant, className)
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.alertContainer
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: classes.headingContainer
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    className: "icon",
    icon: iconMapping[variant]
  }), subText && /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: "subText",
    style: {
      marginRight: '2px'
    }
  }, subText), /*#__PURE__*/_react["default"].createElement(_core.Typography, {
    className: "text"
  }, text))), showCloseButton && /*#__PURE__*/_react["default"].createElement(_core.IconButton, {
    onClick: onClose,
    className: classes.closeButton
  }, /*#__PURE__*/_react["default"].createElement(_reactFontawesome.FontAwesomeIcon, {
    icon: _proSolidSvgIcons.faTimes,
    size: "sm"
  })));
};
exports.Alert = Alert;